import React, { useEffect, useState } from "react";
import baseUrl from "../../../config/baseUrl"
import axios from "axios";
import { Card, CardContent, Box, Typography, TextField, Grid, Button, InputAdornment, IconButton, Drawer, Checkbox, Autocomplete, MenuItem, CircularProgress  } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import LocalTable from "./LocalTable";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import FilterCreatedOn from "../../../date/FilterCreatedOn";
import FilterUpdatedOn from "../../../date/FilterUpdatedOn";
import { useStateContext } from "../../../context/ContextProvider";

const icon = <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

const LocalSettlement = ({ authCreate, authRead, authUpdate, authDelete, authDownload }) => {
  const { dropdownMerchant } = useStateContext();
  const [downloadLoading, setDownloadLoading] = useState(false);

  const auth = sessionStorage.getItem("user");
  const [merchant, setMerchant] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [createdTo, setCreatedTo] = useState("")
  const [createdFrom, setCreatedFrom] = useState("")
  const [updatedTo, setUpdatedTo] = useState("")
  const [updatedFrom, setUpdatedFrom] = useState("")
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [currencyName, setCurrencyName] = useState([]); 
  const [selectedCurrencies, setSelectedCurrencies] = useState([]); 
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleChange = (event, newValue) => {
    if (!Array.isArray(newValue)) return;
    const selectedValues = newValue.filter(Boolean).map((item) => item.value);
    setSelectedTypes(selectedValues);
  };

  const ReadData = async () => {
    try {
      setLoading(true);
      let values = { 
        settlementMode: 2,
        page: page, 
        searchText: searchItem, 
        limit: 10,
        to: createdTo,
        from: createdFrom,
        To: updatedTo,
        From: updatedFrom,
        status: selectedTypes,
        currency: selectedCurrencies.map((currency) => currency.value),
        id: dropdownMerchant
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(`${baseUrl}/settlemetnt_Trans`, values, config);
      setMessage((result.data.message).toUpperCase());
      setTotalPage(Number(result.data.totalPages));
      const fetchedData = result.data.data;
      setMerchant(fetchedData);
    } catch (error) {
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  const merchantData = async () => {
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result1 = await axios.post(`${baseUrl}/merchantChoosedCurrency`, {}, config);
      if (Array.isArray(result1.data.data)) {
        setCurrencyName(result1.data.data);
      } else {
        console.error("Expected an array but got:", result1.data.data);
        setCurrencyName([]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const types = [
    { value: "0", label: "Failed" },
    { value: "1", label: "Success" },
    { value: "2", label: "Pending" },
    { value: "3", label: "Admin Approval Pending" },
  ];

  const handleClear = () => {
    setSearchItem(""); // Clear the state
  };

  useEffect(() => {
    ReadData();
  }, [page, searchItem, createdTo, createdFrom, updatedTo, updatedFrom, selectedTypes, selectedCurrencies, dropdownMerchant]);
  
  useEffect(() => {
    merchantData(); 
  }, []);


  const downloadExl = () => {
    const auth = sessionStorage.getItem("user");
    setDownloadLoading(true);
    
    const values = {
      settlementMode: 2,
      searchText: searchItem || undefined,
      to: createdTo || undefined,
      from: createdFrom || undefined,
      To: updatedTo || undefined,
      From: updatedFrom || undefined,
      status: selectedTypes.length ? selectedTypes : undefined,
      currency: selectedCurrencies.length ? selectedCurrencies.map((c) => c.value) : undefined,
      id: dropdownMerchant
    };    

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      responseType: "json",
    };

    axios
    .post(`${baseUrl}/localdownloadReportsc`, values, config)
    .then((res) => {
      if (
        res.data &&
        typeof res.data === "object" &&
        ("localSettlementCSV" in res.data)
      ) {
        // Download each CSV string if it exists
        const downloadCSV = (csvString, filename) => {
          if (!csvString) return;
          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        };
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 10000);

        if (res.data.localSettlementCSV) downloadCSV(res.data.localSettlementCSV, `LocalSettlement_Summary_${timestamp}_${randomNum}.csv`);
      } else {
        let csvData;
        if (typeof res.data === "string") {
          csvData = res.data;
        } else if (res.data instanceof Blob) {
          csvData = res.data;
        } else {
          // Can't handle unknown format, show error
          throw new Error("Unexpected response format for CSV");
        }

        const blob =
          csvData instanceof Blob
            ? csvData
            : new Blob([csvData], { type: "text/csv;charset=utf-8" });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 10000);
        const fileName = `Report_${timestamp}_${randomNum}.csv`;
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    })
    .catch((err) => {
      console.log(err);
      alert(err?.response?.data?.message || "Download failed");
    })
    .finally(() => {
      setDownloadLoading(false);
    });
  };  

  return (
    <>
      {downloadLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            flexDirection: "column",
          }}
        >
          <CircularProgress size={60} thickness={5} style={{ color: "white" }} />
          <Typography mt={2} variant="h6" color="white">
            Downloading report...
          </Typography>
        </Box>
      )}
      <Box>
        <Card variant="outlined">
          <CardContent>
            <Grid 
              container
              spacing={2}
              alignItems="center"  // Align items vertically in the center
              sx={{ marginTop: "10px" }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}
              >MERCHANT SETTLEMENT</Typography>
              <Grid 
                container
                spacing={2}
                alignItems="flex-start" 
                sx={{ marginTop: "10px" }}
              >
                {/* 1st Row */}
                <Grid item xs={6} sm={5}>
                  <FilterCreatedOn setCreatedTo={setCreatedTo} setCreatedFrom={setCreatedFrom} />
                </Grid>
                <Grid item xs={6} sm={5}>
                  <FilterUpdatedOn setUpdatedTo={setUpdatedTo} setUpdatedFrom={setUpdatedFrom} />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Button variant="contained" color="primary" sx={{ mr: 1, mb: 1, float: "inline-end" }} size="large" onClick={downloadExl}> Download </Button>
                </Grid>
                {/* <Grid item xs={6} sm={3}>
                  {authCreate ? <AddSettlement dropdownMerchant={dropdownMerchant} /> : ''}
                </Grid> */}
                
                {/* 2nd Row */}  
                <Grid item xs={12} sm={4}>
                  <TextField 
                    id="outlined-basic" 
                    label="SETTLEMENT ID." 
                    variant="outlined" 
                    fullWidth 
                    name="text"
                    value={searchItem}
                    onChange={(e) => setSearchItem(e.target.value)} 
                    InputProps={{
                      endAdornment: searchItem && (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClear} edge="end">
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={types}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label || ""}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    fullWidth
                    renderTags={(value) =>
                      value.length > 0 ? `${value.length} value(s) selected` : ""
                    }
                    value={types.filter((item) => selectedTypes.includes(item.value))} // Convert stored values back to objects
                    onChange={handleChange}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Status" />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={currencyName}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label || ""}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    fullWidth
                    renderTags={(value) =>
                      value.length > 0 ? `${value.length} value(s) selected` : ""
                    }
                    value={selectedCurrencies}
                    onChange={(event, newValue) => setSelectedCurrencies(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Currencies" />
                    )}
                  />
                </Grid>            
              </Grid>

            </Grid>
            <Box
              sx={{
                overflow: {
                  xs: "auto",
                  sm: "unset",
                },
              }}
            >
              <LocalTable merchant={merchant} message={message} page={page} totalPage={totalPage} setPage={setPage} auth={auth} ReadData={ReadData} authRead={authRead} authUpdate={authUpdate} authDelete={authDelete} loading={loading} />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

const AddSettlement = (dropdownMerchant) => {
  const [state, setState] = useState({ right: false });
  const [wallet, setWallet] = useState([]);
  const [currencyName, setCurrencyName] = useState([]); 
  const [currSelect, setCurrSelect] = useState("");
  const [formIncomplete, setFormIncomplete] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const auth = sessionStorage.getItem("user");

  const [formState, setFormState] = useState({
    settlementId: Math.trunc(Math.random() * 1000000),
    accountNumber: '',
    bankName: '',
    branchName: '',
    holderName: '',
    requestedAmount: '',
    swift: '',
    settlementMode: '2'
  });

  const resetForm = () => {
    setFormState({
      settlementId: Math.trunc(Math.random() * 1000000),
      accountNumber: '',
      bankName: '',
      branchName: '',
      holderName: '',
      requestedAmount: '',
      swift: ''
    });
    setCurrSelect('')
  };

  const toggleDrawer = (open) => () => {
    if (!open) {
      resetForm(); 
    }
    setState({ right: open });
    merchantData();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  
  const merchantData = async () => {
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let formData = new FormData();
      formData.append("id", dropdownMerchant.dropdownMerchant);

      let result = await axios.post(`${baseUrl}/userWallet`, formData, config);
      if (Array.isArray(result.data.currencyResult)) {
        setCurrencyName(result.data.currencyResult);
      } else {
        console.error("Expected an array but got:", result.data.currencyResult);
        setCurrencyName([]);
      }
      setWallet(result.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    // merchantData();
  }, [auth, dropdownMerchant]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const requiredFields = {
        'Currency': currSelect,
        'Account Number': formState.accountNumber,
        'Bank Name': formState.bankName,
        'Branch Name': formState.branchName,
        'Account Holder Name': formState.holderName,
        'Requested Amount': formState.requestedAmount,
        'Swift Code': formState.swift,
      };
  
      // Find missing fields
      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value) // Check if the value is empty/null
        .map(([key]) => key); // Get only the field names
  
      if (missingFields.length > 0) {
        setFormIncomplete(true);
        setErrorMessage(`Please fill in all fields: ${missingFields.join(", ")}`);
        setTimeout(() => {
          setFormIncomplete(false);
          setErrorMessage("");
        }, 5000);
        return;
      }
      let values = {
        settlementId: formState.settlementId,
        fromCurrency: currSelect,
        accountNumber: formState.accountNumber,
        bankName: formState.bankName,
        branchName: formState.branchName,
        requestedAmount: formState.requestedAmount,
        account_name: formState.holderName,
        previousBalance: wallet,
        remainingBalance: wallet - Number(formState.requestedAmount),
        swiftCode: formState.swift,
        settlementMode: formState.settlementMode
      };
      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };
      // console.log(values)

      let result = await axios.post(`${baseUrl}/localrequestSettlement`, values, config);
      if (result.status === 200) {
        alert(result.data.message);
        toggleDrawer(false)();
        window.location.reload();
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        sx={{
          mr: 1,
          mb: 1,
          float: "inline-end",
        }}
        size="large"
        onClick={toggleDrawer(true)}
      >
        ADD
      </Button>
      <Drawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer (false)}
      >
        <Box
          sx={{ width: {xs: 300, sm: 500} }}
          role="presentation"
        >
          <div style={{ padding: '20px', position: 'relative' }}>
            <h4>REQUEST SETTLEMENT</h4>
            <button
              style={{
                position: 'absolute',
                top: '22px',
                right: '10px',
                background: '#ff6600',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                padding: '5px',
                width: '25px',
                height: '25px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={toggleDrawer(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
                style={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                }}
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <form onSubmit={handleSubmit} style={{marginTop: "30px"}}>
              <Grid container spacing={2}>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="SETTLEMENT ID"
                    variant="outlined"
                    fullWidth
                    name="settlementId"
                    value={formState.settlementId}
                    disabled
                  />
                </Grid>

                {/* SELECT CURRENCY */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    select
                    label="CURRENCY"
                    value={currSelect}
                    onChange={(e) => setCurrSelect(e.target.value)}
                  >
                    {currencyName.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* SELECT MERCHANT */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="MERCHANT PREVIOUS BALANCE"
                    variant="outlined"
                    fullWidth
                    value={wallet}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="ACCOUNT NUMBER"
                    variant="outlined"
                    fullWidth
                    name="accountNumber"
                    value={formState.accountNumber}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="BANK NAME"
                    variant="outlined"
                    fullWidth
                    name="bankName"
                    value={formState.bankName}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="BRANCH NAME"
                    variant="outlined"
                    fullWidth
                    name="branchName"
                    value={formState.branchName}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="ACCOUNT HOLDER NAME"
                    variant="outlined"
                    fullWidth
                    name="holderName"
                    value={formState.holderName}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="REQUESTED AMOUNT"
                    variant="outlined"
                    fullWidth
                    name="requestedAmount"
                    value={formState.requestedAmount}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="SWIFT CODE"
                    variant="outlined"
                    fullWidth
                    name="swift"
                    value={formState.swift}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="MERCHANT UPDATED BALANCE"
                    variant="outlined"
                    fullWidth
                    name="settledAmount"
                    value={wallet - Number(formState.requestedAmount)}
                    disabled
                  />
                </Grid>

                {/* BUTTON */}
                <Grid item xs={12} style={{ textAlign: "end" }}>
                  {parseFloat(formState.requestedAmount || 0) > parseFloat(wallet) && (
                      <Typography
                        variant="body2"
                        color="error"
                        style={{ marginBottom: "8px", textAlign: "right" }}
                      >
                        Settlement cannot be request. Wallet balance: ({wallet}).
                      </Typography>
                    )}
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={
                        !formState.requestedAmount ||
                        parseFloat(formState.requestedAmount) > parseFloat(wallet)
                      }
                    >
                      Create
                    </Button>
                </Grid>

                {/* ERROR MESSAGE */}
                {formIncomplete && (
                  <Grid item xs={12}>
                    <p style={{ color: "red", textAlign: "center" }}>
                      {errorMessage}
                    </p>
                  </Grid>
                )}
              </Grid>
            </form>
          </div>
        </Box>
      </Drawer>
    </div>
  );
};

export default LocalSettlement;